import React, { useEffect, useState } from 'react';
import axios from 'axios';

// ─────────────────────────────────────────────
// 사용자 등급 관리 (관리탭 > 관리자 전용)
//  - 전체 사용자 목록에서 대상을 고르고 등급을 변경한다
//  - 등급: guest / basic / premium / admin
// ─────────────────────────────────────────────

const GRADES = [
  { value: 'guest',   label: '👤 Guest (손님)' },
  { value: 'basic',   label: '📝 Basic (기본)' },
  { value: 'premium', label: '⭐ Premium (프리미엄)' },
  { value: 'admin',   label: '🔐 Admin (관리자)' },
];

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const selectStyle = {
  width: '100%', padding: '8px',
  border: '1px solid #e2e8f0', borderRadius: '4px',
  fontSize: '13px', fontFamily: 'Arial, sans-serif',
};

export default function UserGradeManager({ cardStyle, titleStyle, subTitleStyle }) {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => { loadUsers(); }, []);

  const loadUsers = async () => {
    try {
      const res = await axios.get('/api/users', auth());
      if (res.data.success) setUsers(res.data.data);
    } catch (e) {
      setMsg('사용자 목록을 불러오지 못했습니다');
    }
  };

  // 사용자를 고르면 현재 등급을 드롭다운에 미리 채워준다
  const pickUser = (userId) => {
    setSelectedUserId(userId);
    const u = users.find((x) => x.user_id === userId);
    setSelectedGrade(u ? u.grade : '');
  };

  const save = async () => {
    if (!selectedUserId || !selectedGrade) {
      setMsg('사용자와 등급을 모두 선택하세요');
      return;
    }
    setMsg('저장 중...');
    try {
      const res = await axios.put(
        `/api/users/${selectedUserId}/grade`,
        { grade: selectedGrade },
        auth()
      );
      if (res.data.success) {
        setMsg('✅ 등급이 변경되었습니다');
        setTimeout(() => { loadUsers(); setMsg(''); }, 1500);
      }
    } catch (e) {
      setMsg('❌ 저장 실패: ' + (e.response?.data?.message || e.message));
    }
  };

  return (
    <div style={cardStyle}>
      <h3 style={titleStyle}>🔐 등급설정</h3>
      <p style={subTitleStyle}>사용자 권한 등급을 변경합니다.</p>

      <div style={{ marginTop: '12px' }}>
        <label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '5px' }}>
          사용자 선택
        </label>
        <select
          value={selectedUserId}
          onChange={(e) => pickUser(e.target.value)}
          style={selectStyle}
        >
          <option value="">사용자를 선택하세요</option>
          {users.map((u) => (
            <option key={u.user_id} value={u.user_id}>
              {u.name} ({u.email}) — {u.grade}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginTop: '12px' }}>
        <label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '5px' }}>
          등급 선택
        </label>
        <select
          value={selectedGrade}
          onChange={(e) => setSelectedGrade(e.target.value)}
          style={selectStyle}
        >
          <option value="">등급을 선택하세요</option>
          {GRADES.map((g) => (
            <option key={g.value} value={g.value}>{g.label}</option>
          ))}
        </select>
      </div>

      <button
        onClick={save}
        style={{
          marginTop: '12px', backgroundColor: '#2563eb', color: 'white',
          border: 'none', padding: '8px 16px', borderRadius: '4px',
          cursor: 'pointer', fontSize: '13px',
        }}
      >
        💾 저장
      </button>

      {msg && (
        <p style={{ fontSize: '11px', color: '#64748b', marginTop: '8px', textAlign: 'center' }}>
          {msg}
        </p>
      )}
    </div>
  );
}
